export type EquityV6Section = {
  title: string;
  body: string;
};

export type EquityV6Compact = {
  intro: string;
  sections: EquityV6Section[];
  note: string | null;
};

/** Flatten compact equity for legacy string consumers (exports, tests). No generation. */
export function flattenEquityV6Compact(compact: EquityV6Compact): string {
  const parts: string[] = [];
  if (compact.intro.trim()) parts.push(compact.intro.trim());
  for (const section of compact.sections) {
    if (section.title.trim() && section.body.trim()) {
      parts.push(`${section.title.trim()}: ${section.body.trim()}`);
    }
  }
  if (compact.note?.trim()) {
    parts.push(`Data note: ${compact.note.trim()}`);
  }
  return parts.join('\n\n');
}
